import {
  AppBar, Avatar, Badge, Box, Divider, Fade, Grid, IconButton, InputBase,
  ListItemIcon, Menu, MenuItem, Stack, Toolbar, Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  CalendarMonth, Email, KeySharp, Logout, MenuOpen, Notifications,
  NotificationsNone, Person, Search, Settings, Storefront,
} from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { Link, useNavigate } from "react-router-dom";
import {
  getLocalValue,
  LoacalVariables,
} from "../../commonFunctions/CommonFunctions";
import LabelDisplay from "../../FrontEnd/UpdateChange/LabelDisplay";
import logo from '../../images/melp-logo-2.svg'
import WSCustomBreadcrumbs from "../BreadCrumbs/BreadCrumbsComp";
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import { WSIcons } from "../../commonFunctions/iIcons";

// import logo from "../../images/logo.png";
interface NavbarProps {
  collapse: boolean;
  drawerWidth?: number;
  handleCollapse: () => void;
  anchorEl: null | HTMLElement;
  badgeContent?: number;
  position?: "fixed" | "absolute" | "relative" | "static" | "sticky";
  backgroundColor?: string;
  iconColor?: string;
  height?: string;
}

const Navbar2: React.FC<NavbarProps> = ({
  collapse,
  drawerWidth = 240,
  handleCollapse,
  badgeContent = 0,
  backgroundColor = "#ffffff",
  iconColor = "#4a4b77",
}) => {
  const [profileAnchor, setProfileAnchor] = useState<null | HTMLElement>(null);
  const openProfileMenu = (event: React.MouseEvent<HTMLElement>) =>
    setProfileAnchor(event.currentTarget);
  const closeProfileMenu = () => setProfileAnchor(null);
 const navigate = useNavigate()
  // State for Notifications Menu
  const [notificationAnchor, setNotificationAnchor] =
    useState<null | HTMLElement>(null);
  const openNotificationMenu = (event: React.MouseEvent<HTMLElement>) =>
    setNotificationAnchor(event.currentTarget);
  const closeNotificationMenu = () => setNotificationAnchor(null);
  const [notifAnchor, setNotifAnchor] = useState<null | HTMLElement>(null);
  return (
    <AppBar
      elevation={0}
      position="fixed"
      color="inherit"
      sx={{
        width: "100%",
        mt: 1,
        border: "1px solid #e3e3e3",
        borderRadius: 8, // Optional: if you don’t want rounded corners
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Grid item container spacing={0} >
        <Grid item sm={12}>
          <Toolbar sx={{ minHeight: 64, marginLeft: 0 }}>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              spacing={2}
            >
              <Grid item xs={12} sm={1} >
                <img src={logo} style={{ marginTop: -2, marginRight: 9, width: "7rem", height: "auto", border: "1px solid #098963", borderRadius: "24px" }}></img>
              </Grid>


              {/* greeting */}
              <Grid item xs={12} sm={7}>
                <LabelDisplay />

                <WSCustomBreadcrumbs />

              </Grid>

              {/* Search */}
              {/* <Grid item xs={12} sm={4} mt={2}
            sx={{
              display: "flex",
              alignItems: "center",
              bgcolor: "#f1f1f1",
              borderRadius: 3,
              p: 1,
              border: "1px solid #098963"
            }}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{
                px: 0.2,
                py: 0.1,
                border: "1px solid #e3e3e3",
                borderRadius: 3,
                cursor: "pointer",
              }}
            >
              {" "}
              <Search sx={{ color: "#555" }} />
            </Stack>
            <InputBase placeholder="Search" sx={{ ml: 1, flex: 1 }} />
          </Grid> */}

              {/* spacer for small screens */}
              <Grid item xs={12} sm={2} ml={3}>

                {/* right controls */}
                <Stack direction="row" alignItems="center" spacing={2}>
                  {/* date selector (static for now) */}
                  {/* <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    sx={{
                      px: 1,
                      py: 0.9,
                      border: "1px solid #098963",
                      borderRadius: 8,
                      cursor: "pointer",
                    }}
                  >
                  
                    <CalendarMonth />
                  </Stack> */}

                  {/* notifications */}
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    sx={{
                      px: 1,
                      py: 0.9,
                      border: "1px solid #098963",
                      borderRadius: 8,
                      cursor: "pointer",
                    }}
                  >
                    <Badge color="error" variant="dot" overlap="circular" >
                      <NotificationsNone sx={{ height: 25, width: 25 }} />
                    </Badge>
                  </Stack>
                  {/* profile avatar */}
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    sx={{
                      px: 1,
                      py: 0.9,
                      border: "1px solid #098963",
                      borderRadius: 8,
                      cursor: "pointer",
                    }}
                    onClick={(e) => setProfileAnchor(e.currentTarget)} // <-- Add this
                  >
                    <Avatar sx={{ width: 25, height: 25 }} />
                    <Typography>Sishanglal</Typography>
                  </Stack>

                </Stack>
              </Grid>
            </Grid>
          </Toolbar>
        </Grid>
      </Grid>
      {/* menus */}
      <Menu
        anchorEl={profileAnchor}
        open={Boolean(profileAnchor)}
        onClose={() => setProfileAnchor(null)}
        TransitionComponent={Fade}
        sx={{ marginLeft: 10 }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >
        <MenuItem
          onClick={() => {
            setProfileAnchor(null);
            // navigate("/profile/view");
          }}
        >
          <WSIcons.Person sx={{ mr: 1 }} />
          Profile
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            setProfileAnchor(null);
            navigate("/logOut");
          }}
        >
          <WSIcons.LogOut sx={{ mr: 1 ,color:'red'}} />
          Logout
        </MenuItem>
      </Menu>

    </AppBar>
  );
};

export default Navbar2;
